import type { ICardProps, IOmit } from '@sixui/ui';
import { Card, CardContent, Text } from '@sixui/ui';
import { cardTokens } from '@sixui/ui/components/Card/Card.stylex';
import { cardContentTokens } from '@sixui/ui/components/CardContent/CardContent.stylex';
import { cardTitleTokens } from '@sixui/ui/components/CardTitle/CardTitle.stylex';
import stylex from '@stylexjs/stylex';

import type { IApiGetAppResponseBody } from '~/lib/api/modules/Apps';
import { AppIcon } from '~/components/atoms/AppIcon';

export type IAppGridItemProps = IOmit<ICardProps, 'children'> & {
  app: IApiGetAppResponseBody;
};

const styles = stylex.create({
  host: {
    width: '100%',
    [cardTokens.containerColor]: 'transparent',
  },
  icon: {
    width: 120,
    height: 120,
    aspectRatio: 1,
  },
  title: {
    textAlign: 'center',
    [cardTitleTokens.headlineSize]: '0.5rem',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  content: {
    [cardContentTokens.topSpace$actionable]: '8px',
    [cardContentTokens.bottomSpace$actionable]: '8px',
  },
});

export const AppGridItem: React.FC<IAppGridItemProps> = (props) => {
  const { app, disabled, ...other } = props;

  return (
    <Card
      sx={styles.host}
      disabled={disabled}
      href={disabled ? undefined : `/apps/${app._id}`}
      variant="filled"
      {...other}
    >
      <AppIcon app={app} sx={styles.icon} />
      <CardContent sx={styles.content}>
        <Text sx={styles.title} variant="label" size="lg">
          {app.name}
        </Text>
      </CardContent>
    </Card>
  );
};
